import React from 'react';
import './HeroHeader.css';
import { preventOrphan } from '../typography';

const TITLE = 'Dominik Hofacker is a Human Interface Designer and Prototyper at Apple.';
const SUBTITLE = 'Specializing in spatial computing and generative AI, he brings expertise from influential roles at Microsoft and Meta.';

function HeroHeader() {
  return (
    <header className="hero-header">
      <div className="hero-eyebrow">
        <span className="hero-eyebrow-logo" aria-hidden="true"></span>
        <span>DESIGN TEAM</span>
      </div>
      <h1 className="hero-title">{preventOrphan(TITLE)}</h1>
      <p className="hero-subtitle">{preventOrphan(SUBTITLE)}</p>
      <div className="hero-links">
        <span className="hero-link">
          <span className="hero-link-icon hero-link-icon--location" aria-hidden="true"></span>
          <a href="https://maps.apple.com/?address=Los%20Angeles,%20CA,%20United%20States&auid=5456946948622042749&ll=34.011417,-118.492010&lsp=7618&q=Santa%20Monica" target="_blank" rel="noreferrer">Based in Los Angeles, CA</a>
        </span>
        <span className="hero-link">
          <span className="hero-link-icon hero-link-icon--link" aria-hidden="true"></span>
          <a href="https://www.linkedin.com/in/dominik-design/" target="_blank" rel="noreferrer">LinkedIn</a>
        </span>
        <span className="hero-link">
          <span className="hero-link-icon hero-link-icon--link" aria-hidden="true"></span>
          <a href="/Resume_DominikHofacker.pdf" target="_blank" rel="noreferrer noindex nofollow">Resume</a>
        </span>
      </div>
    </header>
  );
}

export default HeroHeader;
